import { Box, Typography } from "@mui/material";
import { green, grey } from "@mui/material/colors";

const styles = {
  text: {
    color: grey[400],
    fontWeight: 700,
  },
  small: {
    fontSize: 12,
  },
  green: {
    color: green[500],
  },
};

export default function PitchedIcon({
  size = "medium",
  color = "grey",
}: {
  size?: "small" | "medium";
  color?: "grey" | "green";
}) {
  return (
    <Box>
      <Typography
        sx={[
          styles.text,
          size === "small" && styles.small,
          color === "green" && styles.green,
        ]}
      >
        <Box
          component="i"
          className="fa-regular fa-check-circle"
          sx={{ mr: 0.5 }}
        />
        Pitched
      </Typography>
    </Box>
  );
}
